import { motion } from "framer-motion";
import { cn, animations } from "../../utils/cn";

const SectionHeader = ({ 
  number, 
  title, 
  showLine = true, 
  className = "",
  ...props 
}) => {
  return (
    <motion.div
      className={cn("flex items-center mb-6 sm:mb-8 lg:mb-12 xl:mb-16", className)}
      {...animations.fadeInUp}
      {...props}
    >
      <h2 className="text-xl sm:text-2xl lg:text-3xl font-semibold text-lighterSlate whitespace-nowrap">
        <span className="text-accent font-mono mr-2 sm:mr-3 text-base sm:text-lg lg:text-xl">
          {number}.
        </span>
        {title}
      </h2>
      {showLine && (
        <div className="ml-3 sm:ml-4 lg:ml-5 w-32 sm:w-48 lg:w-72 h-px bg-slate hidden sm:block"></div>
      )}
    </motion.div>
  );
};

export default SectionHeader;